<script lang="ts" setup>
const props = defineProps({
  icon: {
    type: String
  },
  title: {
    type: String
  },
  radius: {
    type: Boolean,
    default: false
  },
  border: {
    type: Boolean,
    default: true
  },
  color: {
    type: String
  }
})
</script>

<template>
  <div class="box">
    <div class="box__icon" :class="[{ radius: props.radius, border: props.border }, props.color]">
      <svg-icon :name="props.icon" />
    </div>
    <div class="box__title">{{ props.title }}</div>
  </div>
</template>

<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
  color: $color-gray-1;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(28);
    height: toRem(28);
    margin-right: toRem(13);
    &.border {
      border: toRem(1) solid $color-gray-line;
    }
    &.radius {
      border-radius: 50%;
    }
    &.color-brand-3 {
      color: $color-brand-3;
    }
    svg {
      width: toRem(16);
      height: toRem(16);
    }
  }
  &__title {
    font-size: toRem(16);
    font-weight: 700;
  }
}
</style>
